import { useSprintQueryClient } from "sprint-common-web";

import { useMovieAssetsApi } from "../../../../assets/list/movies/api/useMovieAssetsApi";
import { GetMovieByIdResponse } from "../../../api/catalogue-api/movie/GetMovieByIdResponse";
import { MovieQueryKey } from "./keys/MovieQueryKey";

export const useGetMovieById = () => {
    const queryClient = useSprintQueryClient();
    const { getMovieById: getMovieByIdUncached } = useMovieAssetsApi();

    const getMovieById = (movieId: string): Promise<GetMovieByIdResponse> => {
        return queryClient.fetchQuery({
            queryKey: [MovieQueryKey.MovieDetails, movieId],
            queryFn: () => getMovieByIdUncached(movieId),
            staleTime: 20000
        });
    };

    return { getMovieById };
};
